var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoManager = function SvgNoManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32.5,
    stroke: "#828384",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828384",
    d: "M33.5 34.5a7.75 7.75 0 1 0 0-15.5 7.75 7.75 0 0 0 0 15.5m5.167-7.75a5.167 5.167 0 1 1-10.334 0 5.167 5.167 0 0 1 10.334 0M49 47.417C49 50 46.417 50 46.417 50H20.583S18 50 18 47.417s2.583-10.334 15.5-10.334S49 44.833 49 47.417m-2.583-.01c-.003-.636-.398-2.548-2.15-4.3-1.684-1.684-4.854-3.44-10.767-3.44s-9.083 1.756-10.767 3.44c-1.752 1.752-2.145 3.664-2.15 4.3z"
  })));
};
export default SvgNoManager;